import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Item, ItemLayout } from '@cld/item';

export const StyleButtonSeparator = styled.div`
  margin-right: ${globalTheme.spacing.xs};
  margin-left: ${globalTheme.spacing.xs};
`;

export const AppWrapper = styled.div`
  align-items: center;
  font-size: 50px;
  flex-direction: column;
  display: block;
  min-width: 480px;
  width: 70%;
  margin: auto;
  background: white;
  padding: 20px;
`;

export const StyleSpinnerContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledPreset = styled.div`
  background-size: contain;
  width: 4rem;
  height: 4rem;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${(props) => props.img});
`;

export const StyledItem = styled(Item)`
  display: flex;
  padding: 0.5rem;
  align-items: center;
`;

export const StyledListContainer = styled.div`
  height: 29rem;
  margin: auto auto 2rem;
  width: 100%;
  border-radius: ${globalTheme.radius.xl};
  border-color: ${globalTheme.palette.secondary};
  margin-top: ${globalTheme.spacing.md};
  border: 1px solid;
  position: relative;
  overflow-y: auto;
`;

export const StyledDownloadContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-right: 2rem;
  margin-top: 2rem;

`;
export const StyledText = styled(ItemLayout)`
  font-size: ${globalTheme.font.size.xs};
`;
